import React from 'react'
import PropTypes from 'prop-types'
import { COLORS } from '@helpers/constants'
import { Border } from './style'

const Table = (props) => {
    const { content: tableData } = props

    if (!tableData) return null

    return (
        <table className={'table-fixed w-full font-secondary'}>
            <thead
                className={`${COLORS.BLACK.TEXT}`}
            >
                <tr>
                    {tableData?.[0]?.map((item, index) => {
                        return (
                            <td className={`align-baseline w-1/${tableData[0].length} ${Border} py-2 px-3 bg-lightGrey`} key={index}>
                                {' '}
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: item,
                                    }}
                                ></span>
                            </td>
                        )
                    })}
                </tr>
            </thead>
            <tbody className={''}>
                {tableData.slice(1, tableData.length).map((row, index) => {
                    return (
                        <tr key={index}>
                            {row.map((cell, index) => (
                                <td className={`${Border} py-2 px-3 align-baseline bg-lightGrey`} key={index}>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: cell,
                                        }}
                                    ></span>
                                </td>
                            ))}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

Table.propTypes = {
    tableData: PropTypes.array,
}

export default Table
